import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventCmsTab extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventCmsTab';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            'guest': true,
            'merchant': true,
            'details': true,
            'features': true,
            'layouts': true,
            'colors': true,
            'home': true,
            'icon': true,
            'profile': true,
            'about': true,
            'agenda': true,
            'restaurant': true,
            'news': true,
            'speaker': true,
            'galleries': true,
            'notifications': true,
            'notification-groups': true,
            'single-notification': false,
            'sponsor': true,
            'report': true,
            'faq': true,
            'general': true,
            'room': true,
            'promo-code': true,
            'evoucher': true,
            'transport': true,
            'flight': true,
            'useful-information': true,
            'iframe': false,
        }
    }

    // static setupInstance(data, { models }) {
    //     console.log("Setup Instance in EventsProfile:",data);
    //     if (data) {
    //         const tempdata= new models.api.EventCmsTab(data.EventLayout)
    //         console.log(tempdata)
    //     }
    //     return data
    // }
}

const servicePath = 'events-cms-tab';
const servicePlugin = makeServicePlugin({
    Model: EventCmsTab,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin